import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Styles for LeaseAuditDetail component
 */
export const useLeaseAuditDetailStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        backgroundColor: theme.palette.grey[50],
    },
    stepperContainer: {
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(0, 3),
    },
    termSelectionContainer: {
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(0, 3),
    },
    tabsContainer: {
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    tabs: {
        minHeight: 48,
    },
    tab: {
        minHeight: 48,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.9rem',
    },
    tabIcon: {
        marginRight: theme.spacing(1),
        fontSize: '1.25rem',
    },
    contentContainer: {
        flex: 1,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    tabPanel: {
        flex: 1,
        overflow: 'auto',
    },
}))

export const useDetailHeaderStyles = makeStyles((theme: Theme) => ({
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
    },
    leftSection: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    title: {
        fontSize: '1.5rem',
        fontWeight: 700,
        color: theme.palette.text.primary,
    },
    rightSection: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    stepsButton: {
        minWidth: 290,
        border: `2px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1, 2),
        textTransform: 'none',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    buttonLabel: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        lineHeight: 1,
    },
    buttonValue: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.dark,
        fontSize: '0.75rem',
        fontWeight: 600,
        padding: theme.spacing(0.25, 0.75),
        borderRadius: theme.spacing(1),
        whiteSpace: 'nowrap',
    },
    actionButton: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1),
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    downloadButton: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
}))

export const useTermSelectionStyles = makeStyles((theme: Theme) => ({
    statTiles: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
    },
    statTile: {
        minWidth: 140,
        padding: theme.spacing(1.5, 2),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
    },
    statTileInteractive: {
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: theme.shadows[2],
        },
    },
    statTileActive: {
        border: `2px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.action.selected,
        boxShadow: theme.shadows[2],
    },
    statLabel: {
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
        fontWeight: 600,
        textTransform: 'uppercase',
    },
    statValue: {
        fontSize: '1.25rem',
        fontWeight: 700,
    },
    headerControls: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
    },
    actionButton: {
        textTransform: 'none',
        fontWeight: 600,
    },
    statsGrid: {
        marginBottom: theme.spacing(2),
    },
    termFilterWrap: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
}))
